import { Footer, SEO } from "@/components/shared";

const Label = ({ children, testId }) => (
  <div className="pt-12 pb-5" data-testid={testId}>
    <p className="container-custom text-[#C9A962] text-xs font-semibold uppercase tracking-[0.25em]">{children}</p>
  </div>
);

export default function FooterPreviewPage() {
  return (
    <div className="pt-24 bg-[#0A1628]">
      <SEO title="Footer Preview" description="Footer style comparison" path="/footer-preview" />
      <div className="container-custom pt-10 pb-4">
        <h1 className="text-3xl md:text-4xl font-bold mb-3">Footer Style Comparison</h1>
        <p className="text-[#A0ABC0]">Option B (light) is shown first. Option A (navy, current) is the live footer at the bottom of this page.</p>
      </div>
      <Label testId="footer-preview-label-light">Option B &middot; Light Ivory</Label>
      <Footer variant="light" />
      <Label testId="footer-preview-label-navy">Option A &middot; Navy (current) &darr;</Label>
    </div>
  );
}
